import AivatarClient from "../AivatarClient";

export async function selfCustomAvatar({
                                           workspaceId,
                                           name,
                                           userFile,
                                       }: {
    workspaceId: number
    name: string
    userFile: File
}) {
    const response = await AivatarClient().postForm(`/workspaces/${workspaceId}/self-custom-avatar`, {
        name,
        userFile,
    })

    return response.data
}

export async function getSelfCustomAvatarHistory(workspaceId: number) {
    const response = await AivatarClient().get(`/workspaces/${workspaceId}/self-custom-avatar`)

    return response.data
}
